import AnueLink from 'fe-common-library/dest/utils/anueLink';

const env = process.env.NODE_ENV === 'production' ? 'prod' : 'beta';
export const LinkFactory = new AnueLink(env);

export default LinkFactory.generateStockLinkBySymbol;
